import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { formatNumberInShort } from "../helper-methods";

const Footer = ({ isVisibleSidebar, toggleSideBar, forHeader }) => {
  const history = useHistory();

  const unreadNotificationCount = useSelector(
    (state) => state?.notificationData?.unreadNotificationCount
  );

  const unreadMessageCount = useSelector(
    (state) => state?.chatData?.unreadMessageCount
  );

  const _navigateTo = (route) => {
    if (isVisibleSidebar) {
      toggleSideBar();
    }
    history.push(route);
  };

  const _isActiveTab = (route) => {
    if (isVisibleSidebar) return false;
    return history?.location?.pathname === route ? true : false;
  };

  return (
    <>
      {/* footer/bottom menu */}
      <nav
        className={`navbar fixed-bottom bottomMenu ${forHeader ? "top-0" : ""}`}
      >
        <ul className="navbar-nav">
          <li className={`nav-item ${_isActiveTab("/feed") ? "active" : ""}`}>
            <div className="nav-link" onClick={() => _navigateTo("/feed")}>
              <svg
                className="inactiveIcon"
                xmlns="http://www.w3.org/2000/svg"
                width="256"
                height="255.946"
                viewBox="0 0 256 255.946"
              >
                <g
                  id="Layer_2_00000124144133331797538500000013861068849108152213_"
                  transform="translate(0.018 0.019)"
                >
                  <g id="_04.home">
                    <g id="Path_55" data-name="Path 55" fill="none">
                      <path
                        d="M246.238,147.143c-5.3,3.65-11,4.55-17.4,4.25-.05,26.349.2,52.147-.15,78.4-.25,14-12.2,25.749-26.2,26s-28.049.1-42.1.05c-4.5,0-7.5-3.25-7.5-8.05-.05-11.849,0-23.7-.05-35.548V188.791c-.05-8.05-5.1-13.2-13.249-13.3q-11.474-.15-22.949,0c-7.95.1-13.049,5.3-13.049,13.249-.05,19.349-.05,38.648-.05,58,0,6.45-2.7,9.15-9.2,9.15h-38.1C39.5,255.837,27.6,244.138,27.5,227.339c-.1-25.3-.05-50.647-.05-75.946-23.2,2.2-36.7-23.9-20.1-40.748Q58.8,59.2,110.295,7.8a30.077,30.077,0,0,1,7.4-5.6c8-4,20.449-2.75,28.049,5.05,19.249,19.749,38.9,39.1,58.4,58.6,14.949,15,29.8,30.1,45,44.9,10,9.75,9.05,28.449-2.9,36.4Z"
                        stroke="none"
                      />
                      <path
                        d="M 184.5824127197266 236.9275817871094 C 190.4441528320312 236.9275817871094 196.3029937744141 236.8946380615234 202.150634765625 236.7902679443359 C 205.9606781005859 236.7222137451172 209.6254119873047 233.1546325683594 209.6902618408203 229.5352172851562 C 209.9221496582031 212.1453247070312 209.8884735107422 194.9540100097656 209.8553619384766 177.6672668457031 C 209.838623046875 168.9335327148438 209.8218994140625 160.1756896972656 209.838623046875 151.3563690185547 L 209.8763122558594 131.4823150634766 L 231.0429382324219 132.4459533691406 C 234.0795288085938 132.4459533691406 234.9110565185547 131.8733215332031 235.7136840820312 131.3235321044922 C 236.3326873779297 130.9117431640625 236.8302001953125 129.7584228515625 236.9516754150391 128.4537353515625 C 237.1228942871094 126.615478515625 236.5389404296875 124.9970550537109 235.8828430175781 124.3573760986328 C 224.1836853027344 112.9660568237305 212.68994140625 101.398796081543 201.2002105712891 89.83437347412109 L 190.704833984375 79.28174591064453 L 174.759521484375 63.38100433349609 C 160.4808349609375 49.162109375 146.2026824951172 34.94279479980469 132.1343688964844 20.50905799865723 C 131.2440948486328 19.59537315368652 129.4882049560547 18.98147964477539 127.7649993896484 18.98147964477539 C 126.8791275024414 18.98148155212402 126.3092269897461 19.14410400390625 126.792366027832 18.87984848022461 C 125.6754150390625 19.48911094665527 124.746467590332 20.1774787902832 123.7099456787109 21.25416374206543 C 89.36815643310547 55.49595260620117 55.07646942138672 89.78768920898438 20.88468170166016 123.9787979125977 C 19.05978584289551 125.8311614990234 18.56078720092773 127.5324249267578 19.31441879272461 129.3327484130859 C 19.71599960327148 130.2920074462891 21.04648399353027 132.5228118896484 25.6555233001709 132.4772186279297 L 46.44868087768555 130.5060577392578 L 46.44241714477539 170.3890075683594 C 46.43304824829102 189.34716796875 46.42357635498047 208.3193664550781 46.49831390380859 227.2255249023438 C 46.54568099975586 235.18701171875 51.85678482055664 236.8740081787109 56.24720764160156 236.8872222900391 L 84.54508209228516 236.8860473632812 C 84.54627990722656 220.8182220458984 84.55332183837891 204.7804718017578 84.59484100341797 188.7405242919922 C 84.59484100341797 170.2867431640625 97.97305297851562 156.7245788574219 116.3958358764648 156.4928436279297 C 124.2109832763672 156.3906555175781 132.04150390625 156.390869140625 139.8261566162109 156.4926300048828 C 158.2628936767578 156.7189025878906 171.7275238037109 170.2524261474609 171.8424224853516 188.7905883789062 L 171.8422546386719 212.1592712402344 L 171.8770599365234 236.8852996826172 L 184.5824127197266 236.9275817871094 M 184.5824279785156 255.9275970458984 C 176.5245208740234 255.9276123046875 168.4593811035156 255.8659210205078 160.3919982910156 255.8372192382812 C 155.8922576904297 255.8372192382812 152.8923645019531 252.5873718261719 152.8923645019531 247.7876434326172 C 152.8424224853516 235.9382171630859 152.8923645019531 224.0887908935547 152.8424224853516 212.2393798828125 C 152.8424224853516 204.4397888183594 152.8424224853516 196.5901641845703 152.8424224853516 188.7905883789062 C 152.7923583984375 180.7409515380859 147.7426300048828 175.5912170410156 139.5930480957031 175.4912109375 C 131.9434356689453 175.3912506103516 124.2937927246094 175.3912506103516 116.6442108154297 175.4912109375 C 108.6945724487305 175.5912170410156 103.594841003418 180.7909545898438 103.594841003418 188.7405242919922 C 103.5448379516602 208.0895843505859 103.5448379516602 227.3886413574219 103.5448379516602 246.7376403808594 C 103.5448379516602 253.1873168945312 100.8449935913086 255.8872222900391 94.34531402587891 255.8872222900391 C 81.64594268798828 255.8872222900391 68.94657897949219 255.8872222900391 56.24720764160156 255.8872222900391 C 39.49805068969727 255.8372192382812 27.59862899780273 244.1378021240234 27.49862861633301 227.3386383056641 C 27.39862823486328 202.0399017333984 27.44868087768555 176.691162109375 27.44868087768555 151.3924255371094 C 4.249900817871094 153.5923767089844 -9.249530792236328 127.4935913085938 7.349681377410889 110.6444778442383 C 41.64794540405273 76.34616088867188 75.94620513916016 42.04790115356445 110.2945251464844 7.79958438873291 C 112.4444198608398 5.549689769744873 114.9442596435547 3.699795007705688 117.6941528320312 2.19984769821167 C 125.6937408447266 -1.799943327903748 138.1431121826172 -0.5499926209449768 145.7427368164062 7.249637126922607 C 164.9917907714844 26.99863624572754 184.6407928466797 46.34769058227539 204.1398468017578 65.84668731689453 C 219.0890960693359 80.84595489501953 233.9383697509766 95.94515991210938 249.1375732421875 110.7444229125977 C 259.1371154785156 120.4939498901367 258.1871032714844 139.1930084228516 246.2377319335938 147.1426391601562 C 240.9379577636719 150.7924194335938 235.2383270263672 151.6924285888672 228.8385772705078 151.3924255371094 C 228.78857421875 177.7411041259766 229.03857421875 203.5398406982422 228.6885833740234 229.7885284423828 C 228.4385833740234 243.7877960205078 216.4892120361328 255.5372161865234 202.4898986816406 255.7872161865234 C 196.5292663574219 255.8936614990234 190.5573425292969 255.9275970458984 184.5824279785156 255.9275970458984 Z"
                        stroke="none"
                        fill="#000"
                      />
                    </g>
                  </g>
                </g>
              </svg>

              <svg
                className="activeIcon"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="256"
                height="256"
                viewBox="0 0 256 256"
              >
                <defs>
                  <clipPath id="clip-path">
                    <rect
                      id="Rectangle_5"
                      data-name="Rectangle 5"
                      width="256"
                      height="256"
                      transform="translate(1592 129)"
                      fill="#ffc7c7"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Mask_Group_5"
                  data-name="Mask Group 5"
                  transform="translate(-1592 -129)"
                  clipPath="url(#clip-path)"
                >
                  <g
                    id="Layer_2_00000124144133331797538500000013861068849108152213_"
                    transform="translate(1592.018 129.045)"
                  >
                    <g id="_04.home">
                      <path
                        id="Path_9"
                        data-name="Path 9"
                        d="M246.238,147.143c-5.3,3.65-11,4.55-17.4,4.25-.05,26.349.2,52.147-.15,78.4-.25,14-12.2,25.749-26.2,26s-28.049.1-42.1.05c-4.5,0-7.5-3.25-7.5-8.05-.05-11.849,0-23.7-.05-35.548V188.791c-.05-8.05-5.1-13.2-13.249-13.3q-11.474-.15-22.949,0c-7.95.1-13.049,5.3-13.049,13.249-.05,19.349-.05,38.648-.05,58,0,6.45-2.7,9.15-9.2,9.15h-38.1C39.5,255.837,27.6,244.138,27.5,227.339c-.1-25.3-.05-50.647-.05-75.946-23.2,2.2-36.7-23.9-20.1-40.748Q58.8,59.2,110.295,7.8a30.077,30.077,0,0,1,7.4-5.6c8-4,20.449-2.75,28.049,5.05,19.249,19.749,38.9,39.1,58.4,58.6,14.949,15,29.8,30.1,45,44.9,10,9.75,9.05,28.449-2.9,36.4Z"
                        stroke="#707070"
                        strokeWidth="0.5"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </li>

          <li
            className={`nav-item ${_isActiveTab("/messages") ? "active" : ""}`}
          >
            <div className="nav-link" onClick={() => _navigateTo("/messages")}>
              <svg
                className="inactiveIcon"
                xmlns="http://www.w3.org/2000/svg"
                id="Outline"
                viewBox="0 0 24 24"
                width="512"
                height="512"
              >
                <path d="M24,11.247A12.012,12.012,0,1,0,12.017,24H19a5.005,5.005,0,0,0,5-5V11.247ZM22,19a3,3,0,0,1-3,3H12.017a10.041,10.041,0,0,1-7.476-3.343,9.917,9.917,0,0,1-2.476-7.814,10.043,10.043,0,0,1,8.656-8.761A10.564,10.564,0,0,1,12.021,2,9.921,9.921,0,0,1,18.4,4.3,10.041,10.041,0,0,1,22,11.342Z" />
                <path d="M8,9h4a1,1,0,0,0,0-2H8A1,1,0,0,0,8,9Z" />
                <path d="M16,11H8a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z" />
                <path d="M16,15H8a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z" />
              </svg>

              <svg
                className="activeIcon"
                xmlns="http://www.w3.org/2000/svg"
                id="Filled"
                viewBox="0 0 24 24"
                width="512"
                height="512"
              >
                <path d="M19.675,2.758A11.936,11.936,0,0,0,10.474.1,12,12,0,0,0,12.018,24H19a5.006,5.006,0,0,0,5-5V11.309l0-.063A12.044,12.044,0,0,0,19.675,2.758ZM8,7h4a1,1,0,0,1,0,2H8A1,1,0,0,1,8,7Zm8,10H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Zm0-4H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z" />
              </svg>

              {unreadMessageCount && unreadMessageCount > 0 ? (
                <span className="badge badge-pill">
                  {formatNumberInShort(unreadMessageCount)}
                </span>
              ) : null}
            </div>
          </li>

          <li
            className={`nav-item ${_isActiveTab("/my-profile") ? "active" : ""
              }`}
          >
            <div
              className="nav-link"
              onClick={() => _navigateTo("/my-profile")}
            >
              <svg
                className="inactiveIcon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="512"
                height="512"
              >
                <g id="_01_align_center" data-name="01 align center">
                  <path d="M21,24H19V18.957A2.96,2.96,0,0,0,16.043,16H7.957A2.96,2.96,0,0,0,5,18.957V24H3V18.957A4.963,4.963,0,0,1,7.957,14h8.086A4.963,4.963,0,0,1,21,18.957Z" />
                  <path d="M12,12a6,6,0,1,1,6-6A6.006,6.006,0,0,1,12,12ZM12,2a4,4,0,1,0,4,4A4,4,0,0,0,12,2Z" />
                </g>
              </svg>

              <svg
                className="activeIcon"
                xmlns="http://www.w3.org/2000/svg"
                id="Layer_1"
                data-name="Layer 1"
                viewBox="0 0 24 24"
                width="512"
                height="512"
              >
                <path d="M16.043,14H7.957A4.963,4.963,0,0,0,3,18.957V24H21V18.957A4.963,4.963,0,0,0,16.043,14Z" />
                <circle cx="12" cy="6" r="6" />
              </svg>
            </div>
          </li>

          <li
            className={`nav-item ${_isActiveTab("/notifications") ? "active" : ""
              }`}
          >
            <div
              className="nav-link"
              onClick={() => _navigateTo("/notifications")}
            >
              <svg
                className="inactiveIcon"
                xmlns="http://www.w3.org/2000/svg"
                id="Outline"
                viewBox="0 0 24 24"
                width="512"
                height="512"
              >
                <path d="M22.555,13.662l-1.9-6.836A9.321,9.321,0,0,0,2.576,7.3L1.105,13.915A5,5,0,0,0,5.986,20H7.1a5,5,0,0,0,9.8,0h.838a5,5,0,0,0,4.818-6.338ZM12,22a3,3,0,0,1-2.816-2h5.632A3,3,0,0,1,12,22Zm8.126-5.185A2.977,2.977,0,0,1,17.737,18H5.986a3,3,0,0,1-2.928-3.651l1.47-6.616a7.321,7.321,0,0,1,14.2-.372l1.9,6.836A2.977,2.977,0,0,1,20.126,16.815Z" />
              </svg>

              <svg
                className="activeIcon"
                xmlns="http://www.w3.org/2000/svg"
                id="Layer_1"
                data-name="Layer 1"
                viewBox="0 0 24 24"
                width="512"
                height="512"
              >
                <path d="M4.068,18H19.724a3,3,0,0,0,2.821-4.021L19.693,6.094A8.323,8.323,0,0,0,11.675,0h0A8.321,8.321,0,0,0,3.552,6.516l-2.35,7.6A3,3,0,0,0,4.068,18Z" />
                <path d="M7.1,20a5,5,0,0,0,9.8,0Z" />
              </svg>

              {unreadNotificationCount && unreadNotificationCount > 0 ? (
                unreadNotificationCount < 100 ? (
                  <span className="badge badge-pill">
                    {formatNumberInShort(unreadNotificationCount)}
                  </span>
                ) : (
                  <span className="badge badge-pill">99+</span>
                )
              ) : null}

            </div>
          </li>

          <li className={`nav-item ${isVisibleSidebar ? "active" : ""}`}>
            <div className="nav-link" onClick={() => toggleSideBar()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="256"
                height="199.111"
                viewBox="0 0 256 199.111"
              >
                <path
                  id="menu_new_"
                  data-name="menu  new "
                  d="M3,19.222A14.222,14.222,0,0,1,17.222,5H244.778a14.222,14.222,0,0,1,0,28.444H17.222A14.222,14.222,0,0,1,3,19.222Zm0,85.333A14.222,14.222,0,0,1,17.222,90.333H244.778a14.222,14.222,0,0,1,0,28.444H17.222A14.222,14.222,0,0,1,3,104.556Zm14.222,71.111a14.222,14.222,0,1,0,0,28.444H244.778a14.222,14.222,0,0,0,0-28.444Z"
                  transform="translate(-3 -5)"
                />
              </svg>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Footer;
